var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treatment-directory-modals"},[_c('treatment-selection-modal'),_c('treatment-directory-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }